import {ShadowPanel} from "../ShadowJsonViewer"
import {NormalizedShadowData} from "../../types/shadow"

interface ShadowFullDataPanelProps {
	rawShadow: NormalizedShadowData
	deviceId: string
}

export const ShadowFullDataPanel = ({rawShadow, deviceId}: ShadowFullDataPanelProps) => (
	<div className="mb-4">
		<h4 className="font-medium text-gray-700 dark:text-gray-300 mb-2">Full Shadow Data:</h4>
		{rawShadow.default && (
			<div className="mb-3">
				<h5 className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
					Default Shadow:
				</h5>
				<div className="overflow-auto max-h-96 rounded">
					<ShadowPanel data={rawShadow.default} shadowType="default" deviceId={deviceId} />
				</div>
			</div>
		)}
		{rawShadow.radar && (
			<div className="mb-3">
				<h5 className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">Radar Shadow:</h5>
				<div className="overflow-auto max-h-96 rounded">
					<ShadowPanel data={rawShadow.radar} shadowType="radar" deviceId={deviceId} />
				</div>
			</div>
		)}
		{!rawShadow.default && !rawShadow.radar && (
			<div className="text-sm text-gray-500 dark:text-gray-400 italic">
				No shadow data available
			</div>
		)}
	</div>
)
